export default __webpack_public_path__ + "static/media/decod.7df33f7d.png";